import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardPaymentRoutes = [
	{
		key: "reward-payment-request",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/payments/requests`,
		component: React.lazy(() => import("views/reward-views/payments/payment-requests/pages/PaymentRequestList")),
	},
	{
		key: "reward-payment-request-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/payments/request/:id`,
		component: React.lazy(() => import("views/reward-views/payments/payment-requests/pages/PaymentRequestDetail")),
	},
	{
		key: "reward-payment-settlement",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order/hr/list`,
		component: React.lazy(() => import("views/reward-views/payments/settlements/pages/HROrderList")),
	},
];
